// @flow
import React, { Component } from 'react';
import { CommonActions } from 'store/actionCreators';
import type { State } from 'store';
import { connect } from 'react-redux';
import { type ContextRouter, type Location, withRouter } from 'react-router-dom';
import ProductsTagCurrent from 'components/tags/ProductsTagCurrent/ProductsTagCurrent';
import { type TagData } from 'store/modules/common';

type OwnProps = {
  tag: string,
};

type Props = OwnProps & {
  selected: ?TagData,
} & ContextRouter;

class ProductsTagCurrentContainer extends Component<Props> {
  initialize = async () => {
    const { tag, history } = this.props;
    try {
      await CommonActions.getProductsTagInfo(tag);
    } catch (e) {
      console.log(e);
      if (e && e.response && e.response.status === 404) {
        history.replace('/404');
      }
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tag !== this.props.tag) {
      this.initialize();
    }
  }

  componentWillUnmount() {
    CommonActions.setProductsTagInfo(null);
  }

  render() {
    const { tag, selected } = this.props;
    return (
      <ProductsTagCurrent
        name={selected ? selected.name : tag}
        count={selected && selected.posts_count}
      />
    );
  }
}

export default connect(
  ({ common }: State) => ({
    selected: common.productsTags.selected,
  }),
  () => ({}),
)(withRouter(ProductsTagCurrentContainer));



// WEBPACK FOOTER //
// ./src/containers/tags/ProductsTagCurrentContainer.js